// 用户模块
import request from "@/tool/request"
import API from "@/tool/api"
import $URL from "@/tool/url"
import qs from "qs";
import { clearAccessToken, setAccessToken } from "@/tool/authStorage";
import authContract from "@/tool/authContract.cjs";
import profileContract from "@/tool/profileContract.cjs";
import developmentSmsCode from "@/tool/developmentSmsCode.cjs";
import { extractProfile, resolveProfileName } from "@/tool/profileView.cjs";
import { resolveAssetUrl } from "@/tool/assetUrl.cjs";
import { updateBasicDataAvatar } from "@/tool/avatarState.cjs";
import {
    createAvatarUploadFormData,
    createDefaultAvatarSubmission,
} from "@/tool/avatarSubmission.cjs";
import defaultAvatar from "@/assets/images/avatar-default.png";

const getErrorMessage = (error, fallback) => {
    if(error && error.response && error.response.data && error.response.data.message){
        return error.response.data.message;
    }
    return fallback;
};

const getResponseMessage = (payload, fallback) => {
    if(payload && payload.message){
        return payload.message;
    }
    const messages = {
        400: "请求参数或验证码无效，请检查后重试",
        401: "登录凭证无效，请重新登录",
        403: "当前账号没有执行此操作的权限",
        404: "账号不存在或已停用",
        409: "账号信息已存在或发生冲突，请检查后重试",
        429: "操作过于频繁，请稍后重试",
        422: "提交信息无效，请检查后重试",
        500: "系统异常，请稍后重试",
    };
    return messages[payload && payload.code] || fallback;
};

export default {
    state: {
        is_login: false,
        sessionVersion: 0,
        user_id: null,
        user_name: null,
        user_type: null,
        user_level: null,
        // ************ 基本资料 ****************
        basic_data: {}, // 基本资料
        basic_data_error: "",
        // ************ 实名认证 ****************
        certification: {}, // 认证资料
        // ************ 我的资源 ****************
        resource: {},
        work_list: [], // 作品列表
        work_detail: {},
        work_style: {}, // 作品列表
        member_works: [], // 作品
        // ************ 服饰管理 ****************
        lease_list: [], // 服饰列表
        lease_detail: {
            goods_address: "",
            goods_city: "",
            position: {}
        }, // 服饰详情
        // ************ 账单明细 ****************
        wallet_list: [],
		//摄影师 过滤条件 风格与距离
		condition_styleDistance:{},
		
    },
    mutations: {
        // ************ 登录注册 ****************
        setLogin(state, arg){
            state.sessionVersion += 1;
            const loginData = arg || {};
            state.is_login = true;
            state.user_id = loginData.userId || loginData.userID;
            const loginName = resolveProfileName(loginData);
            if(loginName) state.user_name = loginName;
            state.user_type = loginData.type;
            state.user_level = loginData.level;
        },
        setAuthenticated(state){
            state.is_login = true;
        },
        hydrateProfile(state, profile = {}){
            state.is_login = true;
            if(profile.userID || profile.userId) state.user_id = profile.userID || profile.userId;
            const profileName = resolveProfileName(profile, state.user_name);
            if(profileName) state.user_name = profileName;
            if(profile.type !== undefined) state.user_type = profile.type;
            if(profile.level !== undefined) state.user_level = profile.level;
        },
        clearUser(state){
            state.sessionVersion += 1;
            state.is_login = false;
            state.user_id = null;
            state.user_name = null;
            state.user_type = null;
            state.user_level = null;
            state.basic_data = {};
            state.basic_data_error = "";
            state.certification = {};
            state.resource = {};
            state.work_list = [];
            state.work_detail = {};
            state.work_style = {};
            state.member_works = [];
            state.lease_list = [];
            state.lease_detail = {
                goods_address: "",
                goods_city: "",
                position: {}
            };
            state.wallet_list = [];
            state.condition_styleDistance = {};
        },
        // ************ 基本资料 ****************
        setBasicData(state, arg){
            const data = arg || {};
            state.basic_data = {
                ...data,
                head_reference: typeof data.head === "string" ? data.head.trim() : "",
                head: resolveAssetUrl(data.head, $URL.baseUrl, defaultAvatar),
            };
        },
        setBasicDataError(state, arg){
            state.basic_data_error = arg || "";
        },
        setAvatar(state, arg){
            state.basic_data = updateBasicDataAvatar(state.basic_data, arg, $URL.baseUrl, defaultAvatar);
        },
        // ************ 实名认证 ****************
        setCertification(state, arg){ // 写入实名认证资料
            state.certification = arg;
        },
        // ************ 摄影师 ****************
        setResource(state, arg){
            state.resource = arg;
        },
        setWorksStyle(state, arg){ // 写入摄影师、化妆师作品风格认证资料
            if(JSON.stringify(arg) == "{}"){
                state.work_style = {
                    address: "",
                    serviceArea: "",
                    position: {}
                }
            }else{
                state.work_style = arg;
            }
        },
        setMemberWorks(state, arg){ // 写入作品
            state.member_works = arg;
        },
        setMemberGoodsList(state, arg){
            state.work_list = arg;
        },
        setMemberGoodsDetail(state, arg){
            state.work_detail = arg;
        },
        // ************ 服饰管理 ****************
        setLeaseList(state, arg){
            state.lease_list = arg;
        },
        setLeaseDetail(state, arg){
            state.lease_detail = arg;
        },
        // ************ 账单明细 ****************
        setWalletList(state, arg){
            state.wallet_list = arg;
        },
		//摄影师过滤列表
		setCondition(state,arg){
			state.condition_styleDistance = arg.data.result
			
		}
    },
    actions: {
		getCondition({ commit }) {
		    request({
		        method: 'GET',
		        url:API.order.bookorderFilter,
		    }).then(res => {
		        if(res.data.code == 200){
					commit("setCondition", res);
				}
		    }).catch(err => {
		        console.log(`获取订单表格接口异常：${err}`)
		    });
		},
        // ************ 登录注册 ****************
        sendCode({ commit }, arg){ // 发送短信验证码
            commit("handleLoading", true);
            return new Promise((resolve, reject) => {
                let url = API.auth.smsCode;
                request.post(url, qs.stringify({ phone: arg }), {
                    skipAuth: true,
                    skipRefresh: true,
                }).then((res) => {
                    commit("handleLoading", false);
                    if(res.data.code == 200 && res.data.success === true){
                        resolve({
                            message: getResponseMessage(res.data, "验证码发送成功"),
                            smsCode: developmentSmsCode.extractDevelopmentSmsCode(res.data),
                        });
                    }else{
                        reject(getResponseMessage(res.data, "验证码获取失败，请稍后重试"));
                    }
                }).catch((error) => {
                    commit("handleLoading", false);
                    reject(getErrorMessage(error, "验证码获取失败，请稍后重试"));
                })
            })
        },
        sendResetCode({ commit }, arg){ // 发送找回密码短信验证码
            commit("handleLoading", true);
            return new Promise((resolve, reject) => {
                request.post(API.auth.resetPasswordSmsCode, qs.stringify({ phone: arg }), {
                    skipAuth: true,
                    skipRefresh: true,
                }).then((res) => {
                    commit("handleLoading", false);
                    if(res.data.code == 200 && res.data.success === true){
                        resolve({
                            message: getResponseMessage(res.data, "找回密码验证码发送成功"),
                            smsCode: developmentSmsCode.extractDevelopmentSmsCode(res.data),
                        });
                    }else{
                        reject(getResponseMessage(res.data, "找回密码验证码获取失败，请稍后重试"));
                    }
                }).catch((error) => {
                    commit("handleLoading", false);
                    reject(getErrorMessage(error, "找回密码验证码获取失败，请稍后重试"));
                })
            })
        },
        sendLoginCode({ commit }, phone){ // 发送登录短信验证码
            commit("handleLoading", true);
            return request.post(API.auth.loginSmsCode, qs.stringify({ phone }), {
                skipAuth: true,
                skipRefresh: true,
            }).then((res) => {
                if(res.data.code == 200 && res.data.success === true){
                    return {
                        message: getResponseMessage(res.data, "登录验证码发送成功"),
                        smsCode: developmentSmsCode.extractDevelopmentSmsCode(res.data),
                    };
                }
                return Promise.reject(getResponseMessage(res.data, "验证码获取失败，请稍后重试"));
            }).catch((error) => Promise.reject(
                typeof error === "string"
                    ? error
                    : getErrorMessage(error, "验证码获取失败，请稍后重试"),
            )).finally(() => commit("handleLoading", false));
        },
        postRegister({ commit }, arg){ // 注册事件
            commit("handleLoading", true);
            return new Promise((resolve) => {
                let url = API.auth.register,
                data;
                try {
                    data = authContract.buildRegistrationPayload(arg);
                } catch (error) {
                    commit("handleLoading", false);
                    resolve({ type: "error", msg: error.message });
                    return;
                }
                request({
                    method: "POST",
                    url,
                    skipAuth: true,
                    skipRefresh: true,
                    headers: { "Content-Type": "application/json" },
                    data
                }).then((res) => {
                    commit("handleLoading", false);
                    if(res.data.code == 200 && res.data.success === true){
                        resolve({
                            type: "success",
                            msg: getResponseMessage(res.data, "注册成功")
                        });
                    }else{
                        resolve({
                            type: "error",
                            msg: getResponseMessage(res.data, "注册失败，请稍后重试")
                        });
                    }
                }).catch((error) => {
                    commit("handleLoading", false);
                    resolve({
                        type: "error",
                        msg: getErrorMessage(error, "注册失败，请稍后重试")
                    });
                })
            })
        },
        postLogin({ commit, dispatch }, arg){ // 登录
            commit("handleLoading", true);
            return new Promise((resolve) => {
                let url = API.auth.login,
                data;
                try {
                    data = authContract.buildLoginPayload(arg);
                } catch (error) {
                    commit("handleLoading", false);
                    resolve({ type: "error", msg: error.message });
                    return;
                }
                request({
                    method: "POST",
                    url,
                    skipAuth: true,
                    skipRefresh: true,
                    headers: { "Content-Type": "application/json" },
                    data
                }).then((res) => {
                    commit("handleLoading", false);
                    const payload = res.data || {};
                    const loginData = payload.data || payload.result || {};
                    const accessToken = loginData.accessToken;
                    if(payload.code == 200 && payload.success !== false && accessToken){
                        setAccessToken(accessToken);
                        commit("setLogin", loginData);
                        const loginResult = {
                            type: "success",
                            msg: getResponseMessage(payload, "登录成功")
                        };
                        dispatch("getBasicData").finally(() => resolve(loginResult));
                    }else{
                        resolve({
                            type: "error",
                            msg: getResponseMessage(payload, "登录失败，请稍后重试")
                        })
                    }
                }).catch((error) => {
                    commit("handleLoading", false);
                    resolve({
                        type: "error",
                        msg: getErrorMessage(error, "登录失败，请稍后重试"),
                    });
                })
            })
        },
        handleForget({ commit }, arg){ // 忘记密码
            commit("handleLoading", true);
            return new Promise((resolve) => {
                let url = API.auth.resetPassword,
                data;
                try {
                    data = authContract.buildResetPasswordPayload(arg);
                } catch (error) {
                    commit("handleLoading", false);
                    resolve({ type: false, msg: error.message });
                    return;
                }
                request({
                    method: "POST",
                    url,
                    skipAuth: true,
                    skipRefresh: true,
                    headers: { "Content-Type": "application/json" },
                    data
                }).then((res) => {
                    commit("handleLoading", false);
                    if(res.data.code == 200 && res.data.success === true){
                        clearAccessToken();
                        commit("clearUser");
                    }
                    resolve({
                        type: res.data.code == 200 && res.data.success === true,
                        msg: getResponseMessage(
                            res.data,
                            res.data.code == 200 ? "密码已重置" : "密码找回失败，请稍后重试",
                        )
                    })
                }).catch((error) => {
                    commit("handleLoading", false);
                    resolve({
                        type: false,
                        msg: getErrorMessage(error, "操作失败，请稍后重试"),
                    });
                })
            })
        },
        postLogout({ commit }){ // 注销
            commit("handleLoading", true);
            return new Promise((resolve) => {
                let url = API.auth.logout;
                request({
                    method: "POST",
                    url,
                    skipRefresh: true,
                }).then((res) => {
                    resolve(res.data && res.data.message);
                }).catch((error) => {
                    resolve(getErrorMessage(error, "退出登录失败"));
                }).finally(() => {
                    clearAccessToken();
                    commit("clearUser");
                    commit("handleLoading", false);
                })
            })
        },
        // ************ 基本资料 ****************
        getBasicData({ state, commit }){
            const sessionVersion = state.sessionVersion;
            commit("setBasicDataError", "");
            return request.get(API.user.info).then((res) => {
                if (sessionVersion !== state.sessionVersion) return res;
                const payload = res.data || {};
                if(payload.code == 200 && payload.success !== false){
                    const profile = extractProfile(payload);
                    if(Object.keys(profile).length){
                        commit("hydrateProfile", profile);
                        commit("setBasicData", profile);
                    }else{
                        commit("setBasicDataError", "个人资料为空，请稍后重试");
                    }
                }else{
                    commit("setBasicDataError", getResponseMessage(payload, "个人资料获取失败，请稍后重试"));
                }
                return res;
            }).catch((error) => {
                if (sessionVersion !== state.sessionVersion) return;
                const message = typeof error === "string"
                    ? error
                    : getErrorMessage(error, "个人资料获取失败，请稍后重试");
                commit("setBasicDataError", message);
                return error && error.response ? error.response : {
                    data: { code: 500, message },
                };
            });
        },
        handleChangeBasic({ dispatch, commit }, arg){ // 修改资料
            commit("handleLoading", true);
            const data = profileContract.buildProfilePayload(arg);
            return new Promise((resolve) => {
                request({
                    method: "POST",
                    url: API.user.info,
                    headers: { "Content-Type": "application/json" },
                    data
                }).then((res) => {
                    commit("handleLoading", false);
                    if(res.data.code == 200){
                        resolve({
                            type: "success",
                            msg: getResponseMessage(res.data, "资料修改成功")
                        })
                        dispatch("getBasicData")
                    }else{
                        resolve({
                            type: "error",
                            msg: getResponseMessage(res.data, "资料修改失败，请稍后重试")
                        })
                    }
                }).catch((error) => {
                    commit("handleLoading", false);
                    resolve({
                        type: "error",
                        msg: getErrorMessage(error, "资料修改失败，请稍后重试"),
                    });
                })
            })
        },
        handleChangeAvatar({ commit }, arg){
            commit("handleLoading", true);
            const isDefaultAvatar = arg === "default";
            const data = isDefaultAvatar
                ? qs.stringify(createDefaultAvatarSubmission())
                : createAvatarUploadFormData(arg);
            return new Promise((resolve) => {
                request({
                    method: "POST",
                    url: API.user.avatar,
                    data
                }).then((res) => {
                    commit("handleLoading", false);
                    if(res.data.code == 200){
                        const head = isDefaultAvatar
                            ? (typeof res.data.data === "string" && res.data.data.trim() ? res.data.data : "default")
                            : res.data.data;
                        if (!head) {
                            resolve({
                                type: "error",
                                msg: "头像修改失败，请稍后重试"
                            });
                            return;
                        }
                        commit("setAvatar", head)
                        resolve({
                            type: "success",
                            msg: getResponseMessage(res.data, "头像修改成功")
                        })
                    }else{
                        resolve({
                            type: "error",
                            msg: getResponseMessage(res.data, "头像修改失败，请稍后重试")
                        })
                    }
                }).catch((error) => {
                    commit("handleLoading", false);
                    resolve({
                        type: "error",
                        msg: getErrorMessage(error, "头像修改失败，请稍后重试"),
                    });
                })
            })
        },
        // ************ 实名认证 ****************
        getRealname({ state, commit }){ // 获取实名认证
            commit("handleLoading", true);
            let userID = state.user_id,
            url = API.user.realname;
            request({
                method: "GET",
                url,
                params: { userID },
            }).then((res) => {
                commit("handleLoading", false);
                if(res.data.code == 200){
                    commit("setCertification", res.data.result)
                }
            }).catch(() => {})
        },
        handleSubmitRealname({ state, commit }, arg){ // 提交实名认证
            commit("handleLoading", true);
            let { name, idcard, idcardPic } = arg,
            userID = state.user_id,
            url = API.user.realname,
            data = qs.stringify({
                userID,
                name,
                idcard,
                idcardPic
            })
            return new Promise((resolve) => {
                request({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    commit("handleLoading", false);
                    resolve({
                        type: res.data.code == 200,
                        msg: res.data.message
                    })
                }).catch(() => {})
            })
        },
        getCertification({ state, commit }){ // 获取校园认证
            commit("handleLoading", true);
            let userID = state.user_id,
            url = API.user.certification;
            request({
                method: "GET",
                url,
                params: { userID },
            }).then((res) => {
                commit("handleLoading", false);
                if(res.data.code == 200){
                    commit("setCertification", res.data.result)
                }
            }).catch(() => {})
        },
        handleSubmitCertification({ state, commit }, arg){ // 提交校园认证
            commit("handleLoading", true);
            let { name, campus, enrol, stucard } = arg,
            userID = state.user_id,
            url = API.user.certification,
            data = qs.stringify({
                userID,
                name,
                campus,
                enrol,
                stucard
            })
            return new Promise((resolve) => {
                request({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    commit("handleLoading", false);
                    resolve({
                        type: res.data.code == 200,
                        msg: res.data.message
                    })
                }).catch(() => {})
            })
        },
        // ************ 修改密码 ****************
        sendChangePasswordCode({ state, commit }){
            const sessionVersion = state.sessionVersion;
            commit("handleLoading", true);
            return request({
                method: "POST",
                url: API.user.passwordSmsCode,
            })
                .then((res) => {
                    if (sessionVersion !== state.sessionVersion) return Promise.reject("账号已变化，请重新操作");
                    if(res.data.code == 200 && res.data.success !== false){
                        return {
                            message: getResponseMessage(res.data, "验证码发送成功"),
                            smsCode: developmentSmsCode.extractDevelopmentSmsCode(res.data),
                        };
                    }
                    return Promise.reject(getResponseMessage(res.data, "验证码获取失败，请稍后重试"));
                })
                .catch((error) => Promise.reject(
                    typeof error === "string"
                        ? error
                        : getErrorMessage(error, "验证码获取失败，请稍后重试"),
                ))
                .finally(() => commit("handleLoading", false));
        },
        handleChangePwd({ state, commit }, arg){
            const sessionVersion = state.sessionVersion; // 修改密码
            commit("handleLoading", true);
            let url = API.user.password,
            data;
            try {
                data = qs.stringify(authContract.buildChangePasswordPayload(arg));
            } catch (error) {
                commit("handleLoading", false);
                return Promise.resolve({ type: "error", msg: error.message });
            }
            return new Promise((resolve) => {
                request({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    if (sessionVersion !== state.sessionVersion) { resolve({ type: "ignored" }); return; }
                    commit("handleLoading", false);
                    if(res.data.code == 200){
                        resolve({
                            type: "success",
                            msg: "修改成功"
                        })
                    }else{
                        resolve({
                            type: "error",
                            msg: getResponseMessage(res.data, "密码修改失败，请稍后重试")
                        })
                    }
                }).catch((error) => {
                    if (sessionVersion !== state.sessionVersion) { resolve({ type: "ignored" }); return; }
                    commit("handleLoading", false);
                    resolve({
                        type: "error",
                        msg: getErrorMessage(error, "修改密码失败，请稍后重试")
                    });
                })
            })
        },
        // ************ 摄影师 ****************
        getPhotographerInfo({ state, commit }){ // 获取摄影师信息
            commit("setResource", {})
            let userID = state.user_id,
            url = API.user.photographer;
            request.get(url, { params: { userID } }).then((res) => {
                if(res.data.code == 200){
                    commit("setResource", res.data.result)
                }
            }).catch(() => {})
        },
        handlePhotographerAvatar({ state, commit }, arg){ // 修改摄影师头像
            commit("handleLoading", true);
            let userID = state.user_id,
            url = API.user.photographer,
            data = qs.stringify({
                userID,
                head: arg
            })
            return new Promise((resolve) => {
                request({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    commit("handleLoading", false);
                    if(res.data.code == 200){
                        resolve({
                            type: true,
                            msg: res.data.result.head
                        })
                    }else{
                        resolve({
                            type: false,
                            msg: res.data.message
                        })
                    }
                }).catch(() => {})
            })
        },
        handlePhotographerCertphoto({ state, commit }, arg){ // 修改摄影师学生证
            commit("handleLoading", true);
            let userID = state.user_id,
            url = API.user.photographer,
            data = qs.stringify({
                userID,
                certphoto: arg
            })
            return new Promise((resolve) => {
                request({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    commit("handleLoading", false);
                    if(res.data.code == 200){
                        resolve({
                            type: true,
                            msg: res.data.message,
                            link: res.data.result.certphoto
                        })
                    }else{
                        resolve({
                            type: false,
                            msg: res.data.message
                        })
                    }
                }).catch(() => {})
            })
        },
        handleModifyPhotographer({ state, commit, dispatch }, arg){ // 修改摄影师信息
            commit("handleLoading", true);
            let { goodat, certphoto, serviceArea, address, briefInfo, position } = arg,
            userID = state.user_id,
            url = API.user.photographer,
            data = qs.stringify({
                userID,
                goodat, 
                certphoto, 
                serviceArea,
                address,
                briefInfo,
                position: position.lat + "," + position.lng
            },
            {
                arrayFormat: 'brackets'
            })
            return new Promise((resolve) => {
                request({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    commit("handleLoading", false);
                    if(res.data.code == 200){
                        resolve({
                            type: true,
                            msg: res.data.message
                        })
                        dispatch("getPhotographerInfo")
                    }else{
                        resolve({
                            type: false,
                            msg: res.data.message
                        })
                    }
                }).catch(() => {})
            })
        },
        getMemberGoodsList({ commit }, { userID, tagID }) { // 获取个人中心-摄影师标签页内商品列表
            commit("handleLoading", true);
            let url = API.user.goodsList;
            request.get(url, { params: { userID, tagID } }).then(res => {
                if(res.data.code == 200){
                    commit('setMemberGoodsList', res.data.result.list)
                }
            }).catch(err => {
                console.log(`获取从业者商品列表接口异常：${err}`)
            }).finally(() => commit('handleLoading', false));
        },
        getMemberGoodsDetail({ commit }, { userID, goodsID }){
            commit("handleLoading", true);
            let url = API.user.goodsDetail;
            request.get(url, { params: { userID, goodsID } }).then(res => {
                if(res.data.code == 200){
                    commit('setMemberGoodsDetail', res.data.result)
                }
            }).catch(err => {
                console.log(`获取从业者商品详情接口异常：${err}`)
            }).finally(() => commit('handleLoading', false));
        },
        deleteMemberGoods({ commit }, { userID, goodsID }) {
            commit("handleLoading", true);
            let url = API.user.deleteGoods,
            data = qs.stringify({
                userID,
                goodsID
            })
            return new Promise(resolve => {
                request({
                    method: 'POST',
                    url,
                    data
                }).then(res => {
                    resolve({
                        type: res.data.code == 200,
                        msg: res.data.message
                    })
                }).catch(err => {
                    console.log(`获取从业者商品详情接口异常：${err}`)
                }).finally(() => commit('handleLoading', false));
            })
        },
        editMemberGoods({ commit }, arg) { // 上传从业者商品详情
            commit("handleLoading", true);
            let {
                userID,
                goodsID,
                tagID,
                openBegin,
                openEnd,
                goodsType,
                name,
                skin,
                detail,
                sketch,
                area,
                address,
                position,
                price,
                unit,
                url
            } = arg,
                data = qs.stringify(
                    {
                        userID,
                        goodsID,
                        tagID,
                        openBegin,
                        openEnd,
                        goodsType,
                        name,
                        skin,
                        detail,
                        sketch,
                        area,
                        address,
                        position,
                        price,
                        unit
                    },
                    {
                        arrayFormat: 'brackets'
                    }
                );
            return new Promise(resolve => {
                request({
                    method: 'POST',
                    url,
                    data
                }).then(res => {
                    resolve({
                        type: res.data.code == 200,
                        msg: res.data.message
                    })
                }).catch(err => {
                    console.log(`上传从业者商品详情接口异常：${err}`)
                }).finally(() => commit('handleLoading', false));
            })
        },
        // ************ 化妆师 ****************
        getDresserInfo({  state, commit }){
            commit("setResource", {})
            let userID = state.user_id,
            url = API.user.dresser;
            request.get(url, { params: { userID } }).then((res) => {
                if(res.data.code == 200){
                    commit("setResource", res.data.result)
                }
            }).catch(() => {})
        },
        handleDresserAvatar({  state, commit }, arg){ // 修改化妆师头像
            commit("handleLoading", true);
            let userID = state.user_id,
            url = API.user.dresser,
            data = qs.stringify({
                userID,
                head: arg
            })
            return new Promise((resolve) => {
                request({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    commit("handleLoading", false);
                    if(res.data.code == 200){
                        resolve({
                            type: true,
                            msg: res.data.result.head
                        })
                    }else{
                        resolve({
                            type: false,
                            msg: res.data.message
                        })
                    }
                }).catch(() => {})
            })
        },
        handleModifyDresser({  state, commit, dispatch }, arg){ // 修改化妆师信息
            commit("handleLoading", true);
            let { goodat, certphoto, serviceArea, address, briefInfo, position } = arg,
            userID = state.user_id,
            url = API.user.dresser,
            data = qs.stringify({
                userID,
                goodat, 
                certphoto, 
                serviceArea,
                address,
                briefInfo,
                position: position.lat + "," + position.lng
            },
            {
                arrayFormat: 'brackets'
            })
            return new Promise((resolve) => {
                request({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    commit("handleLoading", false);
                    if(res.data.code == 200){
                        resolve({
                            type: true,
                            msg: res.data.message
                        })
                        dispatch("getDresserInfo")
                    }else{
                        resolve({
                            type: false,
                            msg: res.data.message
                        })
                    }
                }).catch(() => {})
            })
        },
        getWorksStyle({ state, commit }, arg){ // 获取摄影师/化妆师作品风格认证资料
            commit("handleLoading", true);
            let userID = state.user_id,
            url = API.user.worksStyle;
            request.get(url, { params: { userID, type: arg } }).then((res) => {
                commit("handleLoading", false);
                if(res.data.code == 200){
                    commit("setWorksStyle", res.data.result);
                }
            }).catch(() => {})
        },
        handleSaveWorksStyle({ state, commit }, arg){ // 保存摄影师/化妆师风格认证资料
            commit("handleLoading", true);
            let { type, styleIDs, serviceArea, briefInfo, address, position } = arg,
            userID = state.user_id,
            url = API.user.worksStyle,
            data = qs.stringify({
                userID,
                type,
                styleIDs,
                serviceArea,
                briefInfo,
                address,
                position: position.lat + "," + position.lng
            })
            return new Promise((resolve) => {
                request({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    commit("handleLoading", false);
                    resolve({
                        type: res.data.code == 200,
                        msg: res.data.message
                    })
                }).catch(() => {})
            })
        },
        getMemberWorks({ state, commit }, arg){ // 获取成员作品
            let userID = state.user_id,
            url = API.user.certWorks;
            request.get(url, { params: { userID, type: arg } }).then((res) => {
                if(res.data.code == 200){
                    commit("setMemberWorks", res.data.result)
                }
            }).catch(() => {})
        },
        handleUploadWorks({ state, commit }, arg){ // 上传作品
            let { type, styleID, image, mid } = arg,
            userID = state.user_id,
            url = API.user.uploadCertWorks,
            data = qs.stringify({
                userID,
                type,
                styleID,
                mid,
                image
            })
            return new Promise((resolve) => {
                request({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    resolve({
                        type: res.data.code == 200,
                        msg: res.data.message
                    })
                    if(res.data.code == 200){
                        commit("setMemberWorks", res.data.result)
                    }
                }).catch(() => {})
            })
        },
        // ************ 服饰管理 ****************
        getLeaseList({ state, commit }){ // 获取服饰列表
            commit("handleLoading", true);
            let userID = state.user_id,
            url = API.user.leaseList;
            request.get(url, { params: { userID } }).then((res) => {
                commit("handleLoading", false);
                if(res.data.code == 200){
                    commit("setLeaseList", res.data.result)
                }
            }).catch(() => {})
        },
        getLeaseDetail({ state, commit }, arg){ // 获取服饰详情
            commit("handleLoading", true);
            let userID = state.user_id,
            url = API.user.leaseDetail;
            request.get(url, { params: { userID, goodsID: arg } }).then((res) => {
                commit("handleLoading", false);
                if(res.data.code == 200){
                    commit("setLeaseDetail", res.data.result)
                }
            }).catch(() => {})
        },
        handleLeaseDel({ state, commit }, arg){ // 删除服饰
            commit("handleLoading", true);
            let userID = state.user_id,
            url = API.user.deleteLease,
            data = qs.stringify({
                userID,
                goodsID: arg
            })
            return new Promise((resolve) => {
                request({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    commit("handleLoading", false);
                    if(res.data.code == 200){
                        commit("setLeaseList", res.data.result)
                    }
                    resolve({
                        type: res.data.code == 200,
                        msg: res.data.message
                    })
                }).catch(() => {})
            })
        },
        handleUploadLeasePic({ state, commit }, arg){ // 上传服饰图片
            commit("handleLoading", true);
            let userID = state.user_id,
            url = API.user.uploadImage,
            data = qs.stringify({
                userID,
                image: arg
            })
            return new Promise((resolve) => {
                request({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    commit("handleLoading", false);
                    if(res.data.code == 200){
                        commit("setLeaseList", res.data.result)
                    }
                    resolve({
                        type: res.data.code == 200,
                        msg: res.data.message,
                        result: res.data.result
                    })
                }).catch(() => {})
            })
        },
        handleAddLease({ state, commit }, arg){ // 添加服饰
            commit("handleLoading", true);
            let { goodsName, skin, images, bwh, size, linkType, phone, style, deposit, price, city, address, synopsis, detail, showStatus, position } = arg,
            userID = state.user_id,
            url = API.user.addLease,
            data = qs.stringify(
                {
                    userID,
                    goodsName,
                    skin,
                    images,
                    bwh,
                    size,
                    linkType,
                    phone,
                    style,
                    deposit,
                    price,
                    city,
                    address,
                    synopsis,
                    detail,
                    showStatus,
                    position:  position.lat + "," + position.lng
                },
                {
                    arrayFormat: 'brackets'
                }
            )
            return new Promise((resolve) => {
                request({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    if(res.data.code == 200){
                        commit("setLeaseList", res.data.result)
                    }
                    resolve({
                        type: res.data.code == 200,
                        msg: res.data.message
                    })
                }).catch(err => {
                    console.log(`添加服饰详情接口异常：${err}`)
                }).finally(() => {commit('handleLoading', false);})
            })
        },
        handleChangeLease({ state, commit }, arg){ // 编辑服饰
            commit("handleLoading", true);
            let { 
                goodsName,
                goodsID,
                skin,
                images,
                bwh,
                size,
                linkType,
                phone,
                style,
                deposit,
                price,
                city,
                address,
                synopsis,
                detail,
                showStatus,
                rentSale,
                position
            } = arg,
            userID = state.user_id,
            url = API.user.editLease,
            data = qs.stringify({
                userID,
                goodsName,
                goodsID,
                skin,
                images,
                bwh,
                size,
                linkType,
                phone,
                style,
                deposit,
                price,
                city,
                address,
                synopsis,
                detail,
                showStatus,
                rentSale,
                position:  position.lat + "," + position.lng
            },
            {
                arrayFormat: 'brackets'
            })
            return new Promise((resolve) => {
                request({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    commit("handleLoading", false);
                    if(res.data.code == 200){
                        commit("setLeaseList", res.data.result)
                    }
                    resolve({
                        type: res.data.code == 200,
                        msg: res.data.message
                    })
                }).catch(err => {
                    console.log(`编辑服饰详情接口异常：${err}`)
                }).finally(() => commit('handleLoading', false))
            })
        },
        // ************ 账单明细 ****************
        getWalletList({ commit }, {url, params}){
            commit('handleLoading', true);
            request({
                method: 'POST',
                url,
                data: params
            }).then((res) => {
                if(res.data.code == 200){
                    commit('setWalletList', res.data.result)
                }
            }).catch(() => {
            }).finally(() => {
                commit('handleLoading', false);
            })
        },
        handleWithdraw({ rootState, commit }, arg){ // 提现
            commit("handleLoading", true);
            let userID = rootState.user.user_id,
            url = API.user.withdraw,
            data = qs.stringify({
                userID,
                money: arg
            })
            return new Promise((resolve) => {
                request({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    commit("handleLoading", false);
                    if(res.data.code == 200){
                        commit("setBasicData", res.data.result);
                        resolve({
                            type: res.data.code == 200,
                            msg: res.data.message
                        })
                    }
                }).catch(() => {})  
            })
        }
    },
}
